export default "__VITE_ASSET__9078003a__"